import React from 'react';
import brandConversionService from '../services/brandConversionService';

/**
 * Sticky banner at the top of the Featured Wall — "TODAY'S PARTY PATRON".
 * Shows brand logo + name + the patron's custom message and an optional promo CTA.
 */
export default function PartyPatronBanner({ patron, onClick }) {
  if (!patron) return null;

  const handlePromoClick = () => {
    if (patron.brandId) {
      brandConversionService.logPromoClicked(patron.brandId, { partyPatronId: patron.id }).catch(() => {});
    }
  };

  return (
    <div
      onClick={onClick}
      className="cursor-pointer border-b-2 border-black bg-white"
      role={onClick ? 'button' : undefined}
    >
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
        {patron.brandLogoUrl ? (
          <img src={patron.brandLogoUrl} alt={patron.brandName} className="w-10 h-10 border-2 border-black object-contain bg-white" />
        ) : (
          <div className="w-10 h-10 border-2 border-black flex items-center justify-center font-mono text-xs">★</div>
        )}
        <div className="flex-1 min-w-0">
          <p className="font-mono text-[10px] uppercase tracking-wider text-gray-500">Today's Party Patron</p>
          <p className="font-mono text-sm font-bold uppercase tracking-wider truncate">{patron.brandName}</p>
          {patron.customMessage && (
            <p className="font-mono text-xs text-gray-700 truncate">{patron.customMessage}</p>
          )}
        </div>
        {patron.promoLink && (
          <a
            href={patron.promoLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => { e.stopPropagation(); handlePromoClick(); }}
            className="font-mono text-[10px] font-bold uppercase tracking-wider underline whitespace-nowrap"
          >
            Redeem ↗
          </a>
        )}
      </div>
    </div>
  );
}
